var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.3 74.3H188.7V63.8C188.7 60.9 186.4 58.6 183.5 58.6C180.6 58.6 178.3 60.9 178.3 63.8V74.2H147V63.8C147 60.9 144.7 58.6 141.8 58.6C138.9 58.6 136.6 60.9 136.6 63.8V74.2H105.3V63.8C105.3 60.9 103 58.6 100.1 58.6C97.2 58.6 94.9 60.9 94.9 63.8V74.2H72.2C64.5 74.2 58.3 80.4 58.3 88.1V211.6C58.3 219.3 64.5 225.5 72.2 225.5H211.4C219.1 225.5 225.3 219.3 225.3 211.6V88.2C225.2 80.5 219 74.3 211.3 74.3ZM214.8 211.7C214.8 213.6 213.2 215.2 211.3 215.2H72.2C70.3 215.2 68.7 213.6 68.7 211.7V88.2C68.7 86.3 70.3 84.7 72.2 84.7H94.8V95.1C94.8 98 97.1 100.3 100 100.3C102.9 100.3 105.2 98 105.2 95.1V84.7H136.5V95.1C136.5 98 138.8 100.3 141.7 100.3C144.6 100.3 146.9 98 146.9 95.1V84.7H178.2V95.1C178.2 98 180.5 100.3 183.4 100.3C186.3 100.3 188.6 98 188.6 95.1V84.7H211.2C213.1 84.7 214.7 86.3 214.7 88.2V211.7H214.8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.7 121.2H94.8V136.9H115.7V121.2Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.7 147.3H94.8V163H115.7V147.3Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.7 173.4H94.8V189.1H115.7V173.4Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.2 173.4H131.3V189.1H152.2V173.4Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.2 147.3H131.3V163H152.2V147.3Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.2 121.2H131.3V136.9H152.2V121.2Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M188.7 173.4H167.8V189.1H188.7V173.4Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.7 147.3H167.8V163H188.7V147.3Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188.7 121.2H167.8V136.9H188.7V121.2Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2c5bbd1e.svg";
export { ForwardRef as ReactComponent };